export default {
  id: "string",
  name: (data, prop) => {
    return data.replace(" ", "")
  },
  params: "array",
  settings: "object"
}



// WEBPACK FOOTER //
// ./src/store/models/block.js